import { ListAppointment } from '~/domain/usecases/appointment/redux/ListAppointment';
import {
  iActionList,
  iActionListFailed,
  iActionListSuccess,
  AppointmentTypes,
} from '~/domain/interfaces/redux/appointment/list';

export const listRequest = (payload: ListAppointment.Params): iActionList => ({
  type: AppointmentTypes.LIST,
  payload,
});

export const listSuccess = (
  params: ListAppointment.Model,
): iActionListSuccess => ({
  type: AppointmentTypes.LIST_SUCCESS,
  payload: params,
});

export const listFailed = (): iActionListFailed => ({
  type: AppointmentTypes.LIST_FAILED,
});
